<template>
	<v-app>
		<Sidebar />
		<Topmenubar :breadcrumbs="this.breadcrumb" />
		<v-main>
			<Subheadertabs :subheadertabs="this.subheadertabs" ref="subheadertabs" />

			<v-container class="p-5" fluid>
				<v-card elevation="0" class="p-5 h-100">
					<h1 class="text-primary">Widgets</h1>
					<p>Voeg maatwerk javascript code toe op de onderstaande pagina’s.</p>

					<v-row>
						<v-col cols="12">
							<v-textarea v-model="setting.checkoutpagewidget" outlined name="input-7-4" label="Checkout pagina's:" placeholder="<script></script>" value=""></v-textarea>
						</v-col>
					</v-row>

					<v-row>
						<v-col cols="12">
							<v-textarea v-model="setting.thankyoupagewidget" outlined name="input-7-4" label="Bedankt pagina's:" placeholder="<script></script>" value=""></v-textarea>
						</v-col>
					</v-row>

					<v-row>
						<v-col cols="12" class="ml-auto text-right">
							<v-btn color="secondary" right @click="submitdata" elevation="0"> Opslaan </v-btn>
						</v-col>
					</v-row>
				</v-card>
			</v-container>
		</v-main>
	</v-app>
</template>
<script>
import Sidebar from "@/components/Sidebar.vue";
import Topmenubar from "@/components/Topmenubar.vue";
import Subheadertabs from "@/components/Subheadertabs.vue";
export default {
	components: {
		Sidebar,
		Topmenubar,
		Subheadertabs,
	},

	props: {
		setting: Object,
		submit: Function,
	},

	data: () => ({
		breadcrumb: [
			{
				text: "Instellingen",
				disabled: false,
				href: "/settings",
			},
			{
				text: "Widgets",
				disabled: true,
				href: "/settings/widgets",
			},
		],
		subheadertabs: [
			{
				text: "Gegevens",
				href: "/settings/general",
			},
			{
				text: "Betalingen",
				href: "/settings/payments",
			},
			{
				text: "Algemene voorwaarden",
				href: "/settings/terms",
			},
			{
				text: "Domeinnaam",
				href: "/settings/domainname",
			},
			{
				text: "Voorkeuren",
				href: "/settings/preferences",
			},
			{
				text: "Widgets",
				href: "/settings/widgets",
			},
		],
	}),
	methods: {
		submitdata() {
			if (this.submit != null) {
				this.submit();
			}
		}
	}
};
</script>

